export default __webpack_public_path__ + "static/media/bl3.9936a608.png";